import { Settings } from '@/components/settings/Settings'

export function SettingsPage() {
  return <Settings />
}
